import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DomainService } from '../../../services/domain.service';
import { ModalService } from '../../../services/modal.service';
import { NewsletterModalComponent } from '../../../../newsletters/newsletter-modal/newsletter-modal.component';

@Component({
  selector: 'app-home-newsletter-section',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './home-newsletter-section.component.html',
})
export class HomeNewsletterSectionComponent {
  showNewsletter = true;

  constructor(
    private domain: DomainService,
    private modal: ModalService,
  ) {
    this.showNewsletter = this.domain.isNewsletterEnabled();
  }

  openNewsletterModal(): void {
    const modalOptions = { size: 'xl' };

    this.modal
      .Modal(NewsletterModalComponent, '', '', {}, [], modalOptions)
      .catch(() => undefined);
  }
}
